import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Car, Storefront, Wrench } from "@phosphor-icons/react";

// Top-bar switcher between the three CRMs. Renders ONLY the sections the
// logged-in user's role/permissions can access (mirrors ModuleProtected).
export const BusinessSwitcher = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  if (!user) return null;

  const hasPerm = (p) => user.role === "admin" || (Array.isArray(user.permissions) && user.permissions.includes(p));
  const tabs = [
    { key: "rental", label: "Rental & Chauffeur", short: "Rental", icon: Car, to: "/", show: true },
    { key: "dealership", label: "Dealership", short: "Dealer", icon: Storefront, to: "/dealership", show: hasPerm("dealership") },
    { key: "mechanic", label: "Mechanic", short: "Shop", icon: Wrench, to: "/mechanic", show: hasPerm("mechanic") },
  ].filter((t) => t.show);

  if (tabs.length <= 1) return null;
  const activeKey = location.pathname.startsWith("/dealership")
    ? "dealership"
    : location.pathname.startsWith("/mechanic")
      ? "mechanic"
      : "rental";

  return (
    <div className="flex items-center gap-1 p-1 rounded-full border border-border bg-white/[0.03] shrink-0" data-testid="business-switcher">
      {tabs.map((t) => {
        const active = t.key === activeKey;
        return (
          <button
            key={t.key}
            onClick={() => navigate(t.to)}
            data-testid={`business-tab-${t.key}`}
            className={`flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs transition-colors duration-150 ${
              active
                ? "bg-primary text-primary-foreground font-medium"
                : "text-muted-foreground hover:text-foreground hover:bg-white/[0.05]"
            }`}
            title={t.label}
            aria-label={t.label}
          >
            <t.icon size={14} weight={active ? "fill" : "regular"} />
            <span className="hidden xl:inline">{t.label}</span>
            <span className={`${active ? "" : "hidden lg:inline"} xl:hidden`}>{t.short}</span>
          </button>
        );
      })}
    </div>
  );
};

export default BusinessSwitcher;
